/**
 * Листание карточек товара: список из адреса, направление шага и переход по
 * номеру. Часть `lib/productNav` (нарезка 14.10.26) — публичные имена те же.
 */

/** Узел слота в шапке каркаса, куда карточка вкладывает свой блок порталом. */
export const TOPBAR_SLOT_ID = "topbar-actions";

/**
 * Параметр адреса со списком товаров, выбранным на «Планах» (замечание
 * владельца 15.09.26: «выбрал нужные планы — перепроверил карточки»). Пока
 * товар открытой карточки в этом списке, стрелки листают его, а не кольцо
 * поставщика. «Поставщики» списком открывают только строку «без поставщика» —
 * кольца у неё нет; остальные строки идут через `startHref`.
 */
export const LIST_PARAM = "list";

/**
 * Потолок списка. Он едет в адресе, а строка запроса за шлюзом ограничена
 * (nginx по умолчанию — 8 КБ на строку): 500 номеров по пять-шесть цифр — около
 * 3 КБ, с запасом под остальной адрес.
 */
export const MAX_LIST = 500;

/**
 * Список товаров из адреса: только целые больше нуля, без повторов, порядок
 * сохранён. Чужой мусор в адресе не роняет листание — он просто не попадает в
 * список, как битая запись хранилища у настроек.
 */
export function listOf(params: URLSearchParams): number[] {
  const out: number[] = [];
  const seen = new Set<number>();
  for (const part of (params.get(LIST_PARAM) ?? "").split(",")) {
    const trimmed = part.trim();
    if (!/^\d+$/.test(trimmed)) continue;
    const id = Number(trimmed);
    if (id <= 0 || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
    if (out.length >= MAX_LIST) break;
  }
  return out;
}

/**
 * Индекс товара по номеру, набранному в счётчике «54 / 153» (замечание
 * владельца 15.09.26: «в начало списка сразу перейти»). Номер человеческий, с
 * единицы. Вне границ — ПРИЖИМАЕТСЯ к первому или последнему: «в конец» это
 * любое большое число, а отказ на 999 при 153 товарах был бы работой без
 * смысла. Не целое число либо пустой набор — `null`, переход не делается.
 */
/**
 * Направление последнего шага листания: `1` — вперёд, `-1` — назад. Им выбирают,
 * чью карточку грузить заранее (23.09.26).
 *
 * ЖИВЁТ В МОДУЛЕ, А НЕ В СОСТОЯНИИ: `ProductNav` на новом товаре
 * перерисовывается, и направление, прожившее один переход, не пережило бы
 * второй. До первого шага готовим следующего — листают обычно вперёд.
 */
let шаг = 1;

export function rememberStep(step: number): void {
  шаг = step > 0 ? 1 : -1;
}

export function lastStep(): number {
  return шаг;
}

/**
 * Товар, который откроется следующим шагом в эту сторону, — его карточку и
 * грузят заранее. Вне набора (`index < 0`) «→» ведёт на первый товар отбора,
 * как и само листание; «←» оттуда не ведёт никуда.
 */
export function neighbourId(
  ids: readonly number[],
  index: number,
  step: number,
): number | undefined {
  if (ids.length === 0) return undefined;
  if (index < 0) return step > 0 ? ids[0] : undefined;
  return ids[index + step];
}

export function jumpIndex(typed: string, total: number): number | null {
  const trimmed = typed.trim();
  if (total <= 0 || !/^\d+$/.test(trimmed)) return null;
  return Math.min(Math.max(Number(trimmed), 1), total) - 1;
}
